<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF MONTHLY FORECAST</b></h5>
    <hr />

    <TableMonthlyForecastIndex :fields="fields.fields" />
  </b-card>
</template>

<script>
import TableMonthlyForecastIndex from "@/table/user/monthlyForecast/TableMonthlyForecastIndex";

export default {
  data() {
    return {
      items: [],

      form: {
        year: ""
      },

      // Option for year
      select: {
        year: []
      },

      // disable month
      disable_month: true,

      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Month",
            key: "month",
            sortable: true
          },
          {
            label: "Status",
            key: "status",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    // this.getMF();
    // this.getYear();
  },
  methods: {
    // Get Year
    getYear() {
      this.$store.dispatch("getYear").then(res => {
        this.select.year.push({
          text: "Please select",
          value: ""
        });
        if (res.data.response && res.data.response.code === 100) {
          res.data.data.forEach(item => {
            this.select.year.push({
              text: item.year,
              value: item.year
            });
          });
        }
      });
    }
    // getMF(year) {
    //   this.items = [];
    //   let url = `year=${year}`;
    //   this.$store.dispatch("getMF", url).then(res => {
    //     res.data.data.data.forEach(element => {
    //       this.items.push({
    //         month: element.month,
    //         status: element.status,
    //         id: element.fc_id,
    //         type: element.type
    //       });
    //     });
    //   });
    // }
  },
  components: {
    TableMonthlyForecastIndex
  }
};
</script>
<style lang="css" scoped></style>
